import {
    useEffect,
    useState,
} from 'react';

// FNP-815: the search input (TableSearchForm inside RecordsTable) and the list hook
// that filters live in DIFFERENT components. A local useState would give each its
// own keyword copy and search would silently do nothing — that was the bug across
// all 13 modules. Module-scoped store, every caller subscribes. Do not replace with
// a local useState.
let globalKeyword = '';
const keywordListeners: Set<(keyword: string) => void> = new Set();

const notifyKeywordChange = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener(keyword));
};

export const useSyntheticUsersSearch = () => {
    const [keyword, setKeyword] = useState<string>(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => {
            setKeyword(newKeyword);
        };
        keywordListeners.add(listener);
        // A consumer mounting after the keyword was set must not start from ''.
        setKeyword(globalKeyword);
        return () => {
            keywordListeners.delete(listener);
        };
    }, []);

    const handleFilterByKeyword = (newKeyword: string) => {
        notifyKeywordChange(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
